'use strict';

var $ = require('./jquery-extend'),
    isString = require('core-utils/modules/functions/lang/is-string'),
    window = require('window'),
    UrlUtilsObj,
    UrlUtils;

/**
 * Componente di utilita' per la manipolazione/interrogazione di una url
 */
UrlUtilsObj = function () {

    /**
     * Si occupa di aggiornare o appendere un parametro alla query string
     * @param url
     * @param key
     * @param value
     * @returns {string}
     */
    var saveParam = function (url, key, value) {
        var re,
            separator,
            hash = '';

        if ($.isEmpty(url)) {
            throw new TypeError('Url param is required');
        }

        if ($.isEmpty(key)) {
            throw new TypeError('Key param is required');
        }

        re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        separator = url.indexOf('?') !== -1 ? '&' : '?';

        if (url.indexOf('#') !== -1) {
            hash = url.substring(url.indexOf('#'));
            url = url.substr(0, url.indexOf('#'));
        }

        if (url.match(re)) {
            url = url.replace(re, '$1' + key + '=' + value + '$2');
        } else {
            url = url + separator + key + '=' + value;
        }

        return url + hash;
    };

    /**
     * Si occupa di convertire una query string di parametri in un oggetto e lo ritorna
     * @param url
     * @returns {{}}
     */
    var parse = function (url) {
        var str = isString(url) ? url : window.location.search;

        if (str === '') {
            return {};
        }

        if (str.charAt(0) === '?') {
            str = str.substring(1);
        }

        return str.split('&').reduce(function (ret, param) {
            var parts = param.replace(/\+/g, ' ').split('='),
                key = parts.shift(),
                val = parts.length > 0 ? parts.join('=') : null;

            key = decodeURIComponent(key);

            if (isString(val)) {
                val = decodeURIComponent(val);
            }

            if (key.match(/\[\]$/)) {
                key = key.replace(/\[\]$/, '');

                if (ret[key] === void(0)) {
                    ret[key] = [val];
                } else {
                    ret[key].push(val);
                }
            } else {
                ret[key] = val;
            }

            return ret;
        }, {});
    };

    /**
     * Si occupa di tornare il valore di un eventuale parametro nella query string
     * @param key
     * @param url
     * @returns {*}
     */
    var getParam = function (key, url) {
        var params;

        if ($.isEmpty(key)) {
            throw new TypeError('Key param is required');
        }

        params = parse(url);

        return $.isDefinedAndNotNull(params[key]) ? params[key] : null;
    };

    /**
     * Si preoccupa di codificare una stringa per una url
     * @param string
     * @returns {string}
     */
    var encode = function (string) {
        return encodeURIComponent(string);
    };

    /**
     * Si preoccupa di decodicare una stringa encodata per una url
     * @param string
     * @returns {string}
     */
    var decode = function (string) {
        return decodeURIComponent(string);
    };

    /**
     * Da una url parziale torna una url assoluta
     * @param url
     * @returns {*}
     */
    var absolute = function (url) {

        if (url.match(/^http:\/\//) || url.match(/^https:\/\//)) {
            return url;
        }

        if (url.charAt(0) !== '/') {
            var path = window.location.pathname;

            if (path.charAt(path.length - 1) !== '/') {
                var components = path.split('/');
                path = components.splice(0, components.length - 1).join('/') + '/';
            }

            url = path + url;
        }

        return window.location.protocol + '//' + window.location.host + url;
    };

    /**
     * Torna una window.location "depurata" da alcune chiavi non necessarie,
     * con polyfill su window.location.origin erroneo SU IE < 10
     * @param key | Se indicata la chiave, invece dell'array di valori verra' ritornata il valore della chiave relativa
     * @param url | Laddove indicata, l'array ritornato si basera' sul parse di questa URL
     * @returns {*}
     */
    var getAllParams = function (key, url) {
        var sUrl = url || '',
            oLocation = typeof window.location !== 'undefined' ? window.location : null,
            paramAccepted = ['hash', 'host', 'hostname', 'href', 'origin', 'pathname', 'port', 'protocol', 'search'],
            aReturn = {};

        if (!$.isEmpty(sUrl)) {
            if(typeof URL !== 'undefined'){
                oLocation = new URL(sUrl)
            }else{
                oLocation = document.createElement('a');
                oLocation.href = sUrl;
            }
        }

        if (!$.isEmpty(oLocation)) {
            //polyfill IE
            if (!oLocation.origin) {
                oLocation.origin = oLocation.protocol + "//" + oLocation.hostname + (oLocation.port ? ':' + oLocation.port : '');
            }

            for (var i in oLocation) {
                if ((!$.isEmpty(sUrl) || Object.prototype.hasOwnProperty.call(oLocation, i)) &&
                    ($.inArray(i, paramAccepted) !== -1)
                ) {
                    aReturn[i] = oLocation[i];
                }

            }
        }

        return (typeof key !== 'undefined') && !$.isEmpty(key) ? aReturn[key] : aReturn;
    };

    return {
        absolute: absolute,
        decode: decode,
        encode: encode,
        getParam: getParam,
        parse: parse,
        saveParam: saveParam,
        getAllParams: getAllParams
    };

};

UrlUtils = new UrlUtilsObj();

module.exports = UrlUtils;
module.exports.UrlUtilsObj = UrlUtilsObj;
